import { forwardRef } from 'react'
import { cn } from '@/lib/utils/cn'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      data-invalid={invalid || undefined}
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full appearance-none rounded-sm border bg-surface text-primary text-md font-sans leading-normal',
        'min-h-20 px-2.5 py-2 resize-y',
        'placeholder:text-tertiary',
        'border-border-default',
        'transition-[border-color,box-shadow] duration-fast',
        'hover:border-border-strong',
        'focus:outline-none focus:border-border-focus focus:shadow-focus',
        'disabled:cursor-not-allowed disabled:bg-surface-sunk disabled:text-text-disabled disabled:border-border-subtle',
        'read-only:bg-surface-sunk',
        invalid &&
          'border-danger focus:border-danger focus:shadow-focus-danger hover:border-danger',
        className,
      )}
      {...rest}
    />
  )
})
